export default __webpack_public_path__ + "static/EXP_Pressemeldung_1_1_en-10c3486a743898eb201424ab38e9e594.jpg";